module.exports = "/_next/static/images/RepeatPurchaseCampaignsMobile-bce8f267500a7dbecf367acb36a9cffb.webp";